"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatAbbreviation = void 0;
const retrommo_types_1 = require("retrommo-types");
const getStatAbbreviation = (stat) => {
    switch (stat) {
        case retrommo_types_1.Stat.Agility:
            return "AGI";
        case retrommo_types_1.Stat.Defense:
            return "DEF";
        case retrommo_types_1.Stat.Intelligence:
            return "INT";
        case retrommo_types_1.Stat.Luck:
            return "LCK";
        case retrommo_types_1.Stat.Strength:
            return "STR";
        case retrommo_types_1.Stat.Wisdom:
            return "WIS";
    }
};
exports.getStatAbbreviation = getStatAbbreviation;
